export const en = {
  // Navigation
  nav: {
    home: 'Home',
    profile: 'Profile',
    schemes: 'Schemes',
    applications: 'Applications',
    fraudCheck: 'Fraud Check',
    learnFinance: 'Learn Finance',
    appTitle: 'Rural Digital Rights',
  },

  // Home Page
  home: {
    welcome: 'Welcome to Rural Digital Rights',
    subtitle: 'Discover government schemes tailored for you',
    getStarted: 'Get Started',
    createProfile: 'Create Your Profile',
    browseSchemes: 'Browse Schemes',
    checkEligibility: 'Check Eligibility',
  },

  // Profile Page
  profile: {
    title: 'Your Profile',
    createTitle: 'Create Your Profile',
    updateTitle: 'Update Your Profile',
    subtitle: 'Tell us about yourself to get personalized scheme recommendations',
    personalInfo: 'Personal Information',
    age: 'Age',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    caste: 'Caste Category',
    general: 'General',
    obc: 'OBC',
    sc: 'SC',
    st: 'ST',
    occupation: 'Occupation',
    farmer: 'Farmer',
    laborer: 'Laborer',
    selfEmployed: 'Self Employed',
    salaried: 'Salaried',
    student: 'Student',
    unemployed: 'Unemployed',
    incomeRange: 'Annual Income Range',
    below1lakh: 'Below ₹1 Lakh',
    '1to3lakh': '₹1-3 Lakhs',
    '3to5lakh': '₹3-5 Lakhs',
    '5to10lakh': '₹5-10 Lakhs',
    above10lakh: 'Above ₹10 Lakhs',
    locationInfo: 'Location Information',
    state: 'State',
    district: 'District',
    pincode: 'Pincode',
    saveProfile: 'Save Profile',
    updateProfile: 'Update Profile',
    profileSaved: 'Profile saved successfully!',
    profileUpdated: 'Profile updated successfully!',
  },

  // Schemes Page
  schemes: {
    title: 'Government Schemes',
    subtitle: 'Discover schemes you are eligible for',
    searchPlaceholder: 'Search schemes...',
    filters: 'Filters',
    category: 'Category',
    level: 'Level',
    central: 'Central',
    state: 'State',
    allCategories: 'All Categories',
    agriculture: 'Agriculture',
    education: 'Education',
    health: 'Health',
    housing: 'Housing',
    employment: 'Employment',
    socialWelfare: 'Social Welfare',
    viewDetails: 'View Details',
    applyNow: 'Apply Now',
    eligibility: 'Eligibility',
    estimatedBenefit: 'Estimated Benefit',
    match: 'Match',
    basedOnProfile: 'Based on your profile',
    noSchemes: 'No schemes found',
    createProfileFirst: 'Create your profile to see personalized recommendations',
    loading: 'Loading schemes...',
    interestedQuestion: 'Are you interested in this scheme?',
    interestedMessage: 'Would you like to save this scheme to get personalized financial advice on how to utilize the benefits?',
    yesInterested: "Yes, I'm Interested",
    noThanks: 'No, Thanks',
    saving: 'Saving...',
    noSchemesFound: 'No schemes found',
    noSchemesFilters: 'No schemes match your current filters. Try adjusting your search or filters.',
    noSchemesAvailable: 'No schemes available at the moment. Please try again later.',
    clearFilters: 'Clear Filters',
  },

  // Scheme Detail Dialog
  schemeDetail: {
    description: 'Description',
    officialWebsite: 'Official Website',
    helpline: 'Helpline',
    close: 'Close',
    visitWebsite: 'Visit official website',
    callHelpline: 'Call helpline',
  },

  // Applications Page
  applications: {
    title: 'My Applications',
    subtitle: 'Track your scheme applications',
    noApplications: 'No applications yet',
    startApplying: 'Start applying for schemes to track them here',
    status: 'Status',
    submittedOn: 'Submitted on',
    referenceNumber: 'Reference Number',
    viewTimeline: 'View Timeline',
  },

  // Fraud Check Page
  fraudCheck: {
    title: 'Fraud Detection',
    subtitle: 'Check if a message or call is a scam',
    inputLabel: 'Enter the message or describe the call',
    inputPlaceholder: 'Paste the message or describe what the caller said...',
    checkButton: 'Check for Fraud',
    checking: 'Analyzing...',
    result: 'Analysis Result',
    safe: 'Safe',
    risky: 'Risky',
    safeMessage: 'This appears to be legitimate',
    riskyMessage: 'This appears to be a potential scam',
    explanation: 'Explanation',
  },

  // Education/Learn Finance Page
  education: {
    title: 'Learn Finance',
    subtitle: 'Get personalized financial advice on your interested schemes and learn how to best utilize the benefits',
    overallPlan: 'Overall Financial Plan',
    overallPlanDesc: 'Get comprehensive advice on how to manage and utilize benefits from all',
    schemesCount: 'schemes together',
    getOverallAdvice: 'Get Overall Advice',
    yourSchemes: 'Your Interested Schemes',
    getAdvice: 'Get personalized financial advice on how to best utilize the benefits from these schemes',
    noSchemes: 'No Interested Schemes Yet',
    noSchemesDesc: 'Browse schemes and mark them as interested to get personalized financial advice',
    getFinancialAdvice: 'Get Financial Advice',
    financialAdvice: 'Financial Advice',
    overallAdviceTitle: 'Overall Financial Plan',
    comprehensiveAdvice: 'Comprehensive Financial Advice for',
    combinedAnalysis: 'Combined analysis of all your interested schemes',
    generatingAdvice: 'Generating personalized financial advice...',
    generatingPlan: 'Generating comprehensive financial plan...',
    overallAdviceLabel: 'Overall Advice',
    keyPoints: 'Key Points',
    utilizationTips: 'How to Utilize the Benefits',
    potentialImpact: 'Potential Impact',
    removeScheme: 'Remove scheme',
  },

  // Common
  common: {
    retry: 'Retry',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    search: 'Search',
    filter: 'Filter',
    clear: 'Clear',
    apply: 'Apply',
    close: 'Close',
  },
};
